export const shopBuilder = (shopData, ownerId) => {

    const currency = shopData.estimated_monthly_sales.split(' ')[0]
    const estimatedMonthlySales = Number(shopData.estimated_monthly_sales.replace('USD $', '').replace(',', ''))

    const data = {
        ...shopData,
        categories: shopData.categories.split('/').filter(item => item),
        phones: shopData.phones.split(":"),
        currency,
        estimated_monthly_sales: estimatedMonthlySales,
        created_at: new Date(),
        owner_id: ownerId,
        alexa_rank: Number(shopData.alexa_rank)
    }
    delete data.original_id
    delete data.updated_at
    delete data.facebook_followers
    delete data.facebook_url
    delete data.instagram_followers
    delete data.instagram_url
    delete data.id
    return data
}


export const handleShopUrl = (url) => {
    let domainName = !url.startsWith('http') ? 'http://'+url : url
    try {
        let hostName = new URL(domainName).hostname
        if(hostName.startsWith('www.')) {
            hostName = hostName.replace('www.', '')
        }
        return hostName
    } catch (e) {
        return null;  
    }
    
}


export const crosspromOptions = [
    {
        key: 'email-newsletter', 
        title: 'Email Newsletter', 
        infoType: 'number',
        infoPlaceholder: 'Number of my Subscribers',
        errorKey: 'missing-subscribers-number',
        errorMessages: ["Missing subscribers' number", "Need a number format"],
        icon: 'subscribers'
    },
    {
        key: 'website-banner',
        title: 'Website Banner',
        infoType: 'url',
        infoPlaceholder: 'Website Link',
        errorKey: 'missing-banner-link',
        errorMessages: ["Missing link", "Please enter a valid URL."],
        icon: 'link'
    },
    {
        key: 'social-media-post',
        title: 'Social Media Post'
    },
    {
        key: 'blog-post',
        title: 'Blog Post',
        infoType: 'url',
        infoPlaceholder: 'Blog page link',
        errorKey: 'missing-blog-page-link',
        icon: 'link',
        errorMessages: ['Missing blog page link', "Please enter a valid URL."]
    },
    {
        key: 'other',
        title: 'Other',
        infoType: 'text',
        infoPlaceholder: 'Enter Description',
        errorKey: 'missing-other-description',
        errorMessages: ['Missing description', 'Not valid format']
    }
]

export const ALEXA_RANGE = [
    {
        start: 0,
        end: 50000
    },
    {
        start: 50000,
        end: 100000
    },
    {
        start: 100000,
        end: 150000
    },
    {
        start: 150000,
        end: 200000
    },
    {
        start: 200000,
        end: 250000
    },
    {
        start: 250000,
        end: 350000
    },
    {
        start: 350000,
        end: Infinity
    },
]
export const MONTHLY_SALES = [
    {
        start: 0,
        end: 30000
    },
    {
        start: 30000,
        end: 70000
    },
    {
        start: 70000,
        end: 100000
    },
    {
        start: 100000,
        end: 150000
    },
    {
        start: 150000,
        end: 180000
    },
    {
        start: 180000,
        end: 230000
    },
    {
        start: 230000,
        end: Infinity
    },
]

export const CATEGORI_MATCH = [
    {
        category: 'home and garden',
        moreRelevant: [
            'home and garden'
        ],
        relevant: [
            'apparel',
            'beauty and fitness',
            'pets and animals'
        ],
    },
    {
        category: 'apparel',
        moreRelevant: [
            'apparel',
            'beauty and fitness',
        ],
        relevant: [
            'home and garden',
            'sports',
        ],
    },
    {
        category: 'beauty and fitness',
        moreRelevant: [
            'apparel',
            'beauty and fitness',
            'sports'
        ],
        relevant: [
            'home and garden',
        ],
    },
    {
        category: 'pets and animals',
        moreRelevant: [
            'pets and animals',
        ],
        relevant: [
            'home and garden',
        ],
    },
    {
        category: 'sports',
        moreRelevant: [
            'sports',
            'beauty and fitness',
        ],
        relevant: [
            'home and garden',
            'apparel'
        ],
    },
]

